import { RouterModule, Routes } from "@angular/router";

// Utils
import { constants } from "../utils/constants";

//Routes
import { HOME_ROUTES } from "./home/home.routing";
import { ADMIN_ROUTES } from "./admin/admin.routing";

//Guards
import { RoleGuard } from "../services/guards/role.guard";

//Components
import { HomeComponent } from "./home/home.component";
import { AdminComponent } from "./admin/admin.component";
import { RequestSearchComponent } from "./requests/request-search/request-search.component";
import { NewRequestComponent } from "./requests/new-request/new-request.component";
import { ConfirmRequestComponent } from "./requests/new-request/confirm-request/confirm-request.component";
import { ConfirmRequestSuccessComponent } from "./requests/new-request/confirm-request/confirm-request-success.component";
import { RequestDetailComponent } from "./requests/request-detail/request-detail.component";

export const PAGES_ROUTES: Routes = [
  {
    path: "home",
    component: HomeComponent,
    children: HOME_ROUTES,
  },
  {
    path: "admin",
    component: AdminComponent,
    children: ADMIN_ROUTES,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [constants.rules.codes.roles.admin.value],
    },
  },
  {
    path: "request-search",
    component: RequestSearchComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    },
  },
  {
    path: "new-request",
    component: NewRequestComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    },
  },
  {
    path: "confirm-request",
    component: ConfirmRequestComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    },
  },
  {
    path: "confirm-request-success",
    component: ConfirmRequestSuccessComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    },
  },
  {
    path: "request-detail/:operation/:number",
    component: RequestDetailComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    },
  },
  { path: "pages", redirectTo: "/pages/home", pathMatch: "full" },
  { path: "pages/**", redirectTo: "pages/home", pathMatch: "full" },
];
export const PAGES_ROUTING = RouterModule.forChild(PAGES_ROUTES);
